import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
export function GuideChapters() {
  const chapters = [{
    number: 1,
    content: 'Qué es la candidiasis vaginal y por qué ocurre'
  }, {
    number: 2,
    content: 'Síntomas más comunes y cómo reconocerlos'
  }, {
    number: 3,
    content: 'Causas y factores que favorecen su aparición'
  }, {
    number: 4,
    content: 'Diferencias con otras afecciones vaginales'
  }, {
    number: 5,
    content: 'Qué hacer si tienes síntomas ahora mismo'
  }, {
    number: 6,
    content: 'Tratamiento médico habitual: qué esperar'
  }, {
    number: 7,
    content: 'Prevención y cuidado íntimo diario'
  }, {
    number: 8,
    content: 'Alimentación y bienestar general'
  }, {
    number: 9,
    content: 'Candidiasis recurrente: por qué vuelve y qué hacer'
  }, {
    number: 10,
    content: 'Cuándo consultar al médico sin dudarlo'
  }, {
    number: 11,
    content: 'Mitos y errores comunes que pueden perjudicarte'
  }, {
    number: 12,
    content: 'Plan práctico de cuidado íntimo paso a paso'
  }];
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-125">
      <div className="max-w-5xl mx-auto" data-id="element-126">
        <motion.div className="flex items-center justify-center gap-3 mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-127">
          <BookOpenIcon className="w-8 h-8 text-button" data-id="element-128" />
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-heading text-center" data-id="element-129">
            Lo que encontrarás en la guía
          </h2>
        </motion.div>

        <motion.div className="overflow-x-auto rounded-2xl shadow-lg" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-130">
          <table className="w-full bg-white" data-id="element-131">
            <thead data-id="element-132">
              <tr className="bg-accent-lilac" data-id="element-133">
                <th className="px-6 py-4 text-left font-heading text-lg text-heading" data-id="element-134">
                  Capítulo
                </th>
                <th className="px-6 py-4 text-left font-heading text-lg text-heading" data-id="element-135">
                  Contenido
                </th>
              </tr>
            </thead>
            <tbody data-id="element-136">
              {chapters.map((chapter, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-137">
                  <td className="px-6 py-4 font-bold text-button text-lg" data-id="element-138">
                    {chapter.number}
                  </td>
                  <td className="px-6 py-4 text-body" data-id="element-139">{chapter.content}</td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>
      </div>
    </section>;
}